<template>
    <div>
        <div class="notification is-warning" v-if="loading == true">
            Loading members ...
        </div>
        <div class="notification is-danger" v-if="loading == false && grades.length == 0">
            No members can be found
        </div>

        <div class="is-pulled-right" v-if="loading == false" style="display:none">
            <input type="text" class="input" v-model="search" placeholder="Search ..."/>
        </div>

        <h4 class="title">Year 2025/2026 Requests</h4>

        <table class="table is-fullwidth is-striped is-hoverable" v-if="loading == false && grades.length > 0">
            <thead>
                <tr>
                    <th>Name</th>
                    
                    <th>Current Allowance</th>
                    <th>Holiday Taken So Far</th>
                    <th>Can Take</th>
                    <th>Requested</th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr >
                    <td>David Hynes</td>
                    
                    <td>8.62</td>
                    <td>0</td>
                    <td><strong>8.62</strong></td>
                    <td>5</td>
                    <td>
                        <button  class="button is-link is-small" @click="showModal=true">Action</button>
                    </td>
                </tr>
                <tr >
                    <td>Kieran McCormick</td>
                   
                    
                    <td>14</td>
                    <td>12</td>
                    <td><strong>2</strong></td>
                    <td>2</td>
                    <td>
                        <button  class="button is-link is-small">Action</button>
                    </td>
                </tr>
               
            </tbody>

        </table>

        <div class="modal" :class="{'is-active' : showModal == true}">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                <p class="modal-card-title">Action Holiday Pay Request</p>
                <button class="delete" aria-label="close" @click="showModal=false"></button>
                </header>
                <section class="modal-card-body">
                    <table class="table is-fullwidth" >
                        <tr>
                            <td>Qualifying Weeks</td>
                            <td>20</td>
                        </tr>
                        <tr>
                            <td>Total Pay (12 weeks)</td>
                            <td>£2400</td>
                        </tr>
                        <tr>
                            <td>Total Hours (12 weeks)</td>
                            <td>120</td>
                        </tr>
                        <tr>
                            <td>Average Hours (12 weeks)</td>
                            <td>10 hours</td>
                        </tr>
                        <tr>
                            <td>Average Pay (12 weeks)</td>
                            <td>£20 per/hour</td>
                        </tr>
                        <tr>
                            <td>Hours Accumulated</td>
                            <td>12</td>
                        </tr>
                        <tr>
                            <td>Hours Requested</td>
                            <td><input class="input is-small" type="number" value="4"/></td>
                        </tr>
                        <tr>
                            <td>Pay Rate</td>
                            <td><input class="input is-small" type="number" value="20"/></td>
                        </tr>
                        <tr>
                            <td>Holiday Date</td>
                            <td><input class="input is-small" type="date" value="2025-12-09"/></td>
                        </tr>
                    </table>
                </section>
                <footer class="modal-card-foot">
                <div class="buttons">
                    <button class="button is-success">Approve</button>
                    <button class="button is-danger">Deny</button>
                </div>
                </footer>
            </div>
            </div>

       
        
    </div>
</template>

<script>
import UtilityService from '@/services/UtilityService.js';
import MemberMixin from '@/mixins/MemberMixin.js';

export default {
    
      name: 'ClientGroups',
        mixins: [MemberMixin],
        data: function () {
            return {
                   search: '',
                   grades: [],
                   loading: false,
                   accessToken: '',
                   showModal: false
                  
            }
        },
        methods: {
            async getGrades() {
                this.loading=true
                UtilityService.getSimpleApiData(this.accessToken, "grades?include_internal=1")
                .then(
                    (grades => {
                        this.$set(this, "grades", grades);
                        this.loading=false
                    }).bind(this)
                );
            },
            
        },
        created() {
            this.getAccessToken()
            .then(() => { 
                this.getGrades();
                
            });
        
        },
        computed : {
            
        }
    }
</script>